import { motion } from "framer-motion";

/**
 * Editorial infinite marquee — single line duplicated for seamless loop.
 */
export default function Marquee({
  items = [],
  speed = 40,
  className = "",
  sep = "◆",
  bg = "bg-ink",
  text = "text-white",
}) {
  const duration = speed;
  const loop = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden ${bg} ${text} ${className}`}
      data-testid="marquee"
      aria-hidden="true"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ ease: "linear", duration, repeat: Infinity }}
      >
        {loop.map((it, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-8 md:gap-14 px-4 md:px-7 py-5 md:py-6 font-display font-black uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-none"
          >
            <span>{it}</span>
            <span className="text-orange-400 text-xl md:text-3xl">{sep}</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
}
